import { Box, BoxProps } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const ChatInputWrapper = styled(Box)<BoxProps>`
  &:not(.inline-wrapper) {
    position: relative;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.24);
    border-radius: 8px;

    // pseudo element for the gradient border used for the chat input
    &:before {
      content: '';
      position: absolute;
      z-index: 1;
      pointer-events: none;
      inset: 0;
      padding: 1px;
      border-radius: 8px;
      background: linear-gradient(to right, #9747ff, #0073e6);
      mask: linear-gradient(#000 0 0, #000) exclude, linear-gradient(#000 0 0, #000) content-box;
    }
  }

  &.blogWrapper {
    box-shadow: none;
  }

  .chatInputRow {
    border-color: var(--vg-colors-gray-100);
    min-height: 74px;
  }

  // handle mobile layout here for chat input loader on ai-tools page
  @media screen and (max-width: 768px) {
    .chatInputRow {
      flex-direction: column;
      height: 100%;
    }

    &:not(.inline-wrapper) {
      .chatInputWrapperContainer {
        height: 115px;
      }
    }

    .chatInputField {
      padding-right: 3rem;
    }

    .chatSubmitRow {
      flex-direction: column;
      gap: 1rem;

      .chatSubmitType {
        align-self: center;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
      }

      .chatSubCategoryOptions {
        width: 100%;
      }

      .chatSubmitBtn {
        align-self: center;
        width: 100%;

        button {
          max-width: 100%;
          width: 100%;
        }
      }
    }

    &.blogWrapper {
      .chatInputWrapperContainer {
        height: 100%;
      }
      .chatSubmitRow {
        .chatSubmitBtn {
          width: fit-content;
          align-self: flex-end;
        }
      }
    }
  }
`;
